/* Neuheiten-Slider der Kollektion (Roadmap 3.8): laedt die neuesten Produkte NACH dem ersten Bild
 * nach, ohne den ersten Seitenaufbau zu belasten - derselbe Rueckfall-Mechanismus wie das Suchpanel
 * in assets/mhsys-kopf.js (requestIdleCallback, sonst ein Zeitgeber).
 *
 * "Neueste zuerst" kann nur der Server: sort_by=created-descending in der URL wirkt auf die GANZE
 * Kollektion, ein Liquid-Sortierfilter saehe nur die ersten 50 geladenen Produkte. Deshalb ein
 * eigener Abruf ueber die Section Rendering API gegen eine Section, die nie in einem Template steht
 * (sections/mhsys-kollektion-neu-inhalt.liquid) - genau wie /search/suggest fuer das Suchpanel.
 *
 * Der Platzhalter (sections/mhsys-kollektion-neu.liquid) steht schon serverseitig auf der Seite,
 * mit reservierter Hoehe (.mhsys-slider--neu, mhsys-weissblau.css) - hier kommen nur die Kacheln rein.
 */
(() => {
  'use strict';

  function laden(ziel) {
    const basis = ziel.dataset.mhsysKollneuUrl;
    if (!basis) return;
    const url = `${basis}?section_id=mhsys-kollektion-neu-inhalt&sort_by=created-descending`;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inhalt = doc.querySelector('[data-mhsys-kollneu-inhalt]');
        if (!inhalt || !inhalt.children.length) {
          /* Keine Neuheiten (z. B. alles ausverkauft oder weniger als eine Handvoll Produkte in der
             Kollektion) - den ganzen Abschnitt inklusive Ueberschrift entfernen statt leer zu zeigen. */
          const abschnitt = ziel.closest('.mhsys-abschnitt');
          if (abschnitt) abschnitt.remove();
          return;
        }
        /* Die Kacheln selbst einsetzen, nicht ihren Wrapper-Div: mhsys-weissblau.css waehlt sie ueber
           ".mhsys-slider > .mhsys-kachel" (Direktkind-Kombinator, wie bei jeder anderen Artikelreihe
           auch) - ein zusaetzlicher Wrapper dazwischen liesse die Regel ins Leere laufen und die
           Kacheln in voller Breite untereinander stehen statt nebeneinander im Slider. */
        ziel.replaceChildren(...[...inhalt.children].map((kind) => document.adoptNode(kind)));
        /* Skeleton-Kacheln sind mit den echten getauscht (Roadmap 1.25) - Ladehinweis fuer
           Screenreader wieder weg. */
        ziel.removeAttribute('aria-busy');
        /* mhsys-slider.js verbindet Pfeile/Wischen nur beim Seitenaufbau - hier erneut anstossen. */
        document.dispatchEvent(new Event('mhsys:slider:neu'));
        /* mhsys-slider.js hat die (damals leere) Spur schon verbunden und prueft die Pfeile nur bei
           scroll/resize - einmal anstossen, sonst bleiben die Pfeile trotz 12 Kacheln versteckt. */
        ziel.dispatchEvent(new Event('scroll'));
      })
      .catch((e) => console.error('Neuheiten-Slider:', e));
  }

  function starten() {
    /* Eigene Markierung, NICHT data-mhsys-bereit: dieselbe Spur traegt auch data-mhsys-slider,
       und mhsys-slider.js setzt data-mhsys-bereit schon beim Seitenaufbau - mit der gemeinsamen
       Markierung fand dieses Skript seinen Slider nie, er blieb leer (gemeldet 21.09.2026). */
    const ziele = document.querySelectorAll('[data-mhsys-kollneu]:not([data-mhsys-kollneu-geladen])');
    ziele.forEach((ziel) => {
      ziel.dataset.mhsysKollneuGeladen = '1';
      laden(ziel);
    });
  }

  if ('requestIdleCallback' in window) requestIdleCallback(starten, { timeout: 4000 });
  else window.addEventListener('load', starten);
})();
